<template>
  <div class="baoxiu_list">
    <section>
      <div  v-infinite-scroll="load" infinite-scroll-disabled="loading"  infinite-scroll-distance="500">
        <li class="baoxiu_item" v-for="(item,ind) in list" :key="ind">
          <p class="baoxiu_flex">
        <span>
            采暖期：{{item.cnq}}
        </span>

          </p>
          <p class="baoxiu_flex">
        <span>
            缴费方式：{{item.sffs}}
        </span>
            <span>
            缴费金额：￥ {{item.sfje}}
        </span>
          </p>
          <p class="baoxiu_flex">
         <span>
            折扣金额：￥ {{item.zkje}}
         </span>
            <span>
            违约金额：￥ {{item.wyje}}
         </span>
          </p>
          <p class="baoxiu_flex">
         <span>
            缴费日期：{{item.sfrq}}
         </span>
          </p>
        </li>
        <p class="no_data" v-if="!list.length">
          暂无缴费记录
        </p>
      </div>
    </section>
<!--    <footer>-->
<!--      <button class="btn_bx" @click="goPage" type="primary">立 即 缴 费</button>-->
<!--    </footer>-->
  </div>

</template>

<script>
  import { payLog } from '@/api'
  export default {
    data() {
      return {
        list: [],
        loading: false,
        data: '1',
        params: {
          customerId: this.$route.query.userId,
          pageSize: 10,
          pageNum: 1
        }
      }
    },
    computed: {
      disabled () {
        return this.loading
      }
    },
    mounted() {
    },
    methods: {
      load() {
        if(!(this.data&&this.data.length)) {
          this.loading = false
          return
        }
        this.loading = true
        payLog(this.params).then(res => {
          this.data = res.data
          this.list = this.list.concat(res.data)
          this.params.pageNum=this.params.pageNum +1
          this.loading = false
        }).finally(()=>{
          this.loading = false
        })
      },
      goPage() {
        this.$router.push({
          path: '/payment',
          query: this.$route.query
        })
      }
    }
  }
</script>

<style scoped>

  .baoxiu_list{
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    width:100%;
    height:90%;
  }

  .btn_bx{
    width: 94%;
    margin-left: 3%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }
  header,footer{
    height:40px;
    line-height: 40px;

    /*text-align:center;*/
  }
  header{
    margin-bottom: 5px;
    background-color:#fff;

  }
  section{
    -webkit-box-flex:1;
    -webkit-flex:1;
    -ms-flex:1;
    flex:1;
    width:100%;
    overflow:auto;/* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }
  .baoxiu_item{
    border-bottom: 5px solid #f1f1f1;
    padding: 3%;
    line-height: 25px;
    background: #fff;
  }
  .baoxiu_flex{
    display: flex;
    justify-content: space-between;
  }
  .goPj{
    color: #1890ff;
  }

</style>



// WEBPACK FOOTER //
// src/view/jryw/jf/payList.vue